import { Button } from '@/shared/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/shared/ui/dropdown-menu';
import { Eye, KeyRound, MoreHorizontal, Pencil, Shield, UserCheck, UserX } from 'lucide-react';

interface UserActionsMenuProps {
  isActive?: boolean;
  hasCognitoAccount?: boolean;
  onView?: () => void;
  onEdit?: () => void;
  onResetPassword?: () => void;
  onManageRoles?: () => void;
  onDeactivate?: () => void;
  onReactivate?: () => void;
}

export function UserActionsMenu({
  isActive = true,
  hasCognitoAccount = true,
  onView,
  onEdit,
  onResetPassword,
  onManageRoles,
  onDeactivate,
  onReactivate,
}: UserActionsMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="h-8 w-8 p-0 text-muted-foreground hover:text-foreground"
          aria-label="Open actions menu"
          onClick={(e) => e.stopPropagation()}
        >
          <MoreHorizontal className="w-4 h-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48" onClick={(e) => e.stopPropagation()}>
        {onView && (
          <DropdownMenuItem onClick={onView}>
            <Eye className="w-4 h-4 mr-2" />
            View Details
          </DropdownMenuItem>
        )}
        {onEdit && (
          <DropdownMenuItem onClick={onEdit}>
            <Pencil className="w-4 h-4 mr-2" />
            Edit User
          </DropdownMenuItem>
        )}
        {onResetPassword && (
          <DropdownMenuItem onClick={onResetPassword} disabled={!hasCognitoAccount}>
            <KeyRound className="w-4 h-4 mr-2" />
            Set Password
          </DropdownMenuItem>
        )}
        {onManageRoles && (
          <DropdownMenuItem onClick={onManageRoles}>
            <Shield className="w-4 h-4 mr-2" />
            Manage Roles
          </DropdownMenuItem>
        )}
        {(onDeactivate || onReactivate) && <DropdownMenuSeparator />}
        {isActive && onDeactivate && (
          <DropdownMenuItem
            onClick={onDeactivate}
            className="text-red-600 dark:text-red-400 focus:text-red-700"
          >
            <UserX className="w-4 h-4 mr-2" />
            Deactivate
          </DropdownMenuItem>
        )}
        {!isActive && onReactivate && (
          <DropdownMenuItem onClick={onReactivate} className="text-green-600 dark:text-green-400">
            <UserCheck className="w-4 h-4 mr-2" />
            Reactivate
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
